var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('td',{class:{ nowrap: _vm.noWrap, 'break-word': _vm.breakWord, autogrow: _vm.autogrow },attrs:{"colspan":_vm.colspan}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }